import { List, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { InfoCard } from '@backstage/core-components';
import { ResourceCard, Resource } from './ResourceCard';
import DescriptionIcon from '@material-ui/icons/Description';
import CodeIcon from '@material-ui/icons/Code';
import TuneIcon from '@material-ui/icons/Tune';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const useStyles = makeStyles(_theme => ({
  list: {
    padding: 0,
  },
  viewAllButton: {
    textTransform: 'none',
  },
}));

const resources: Resource[] = [
  {
    title: 'Prompt Engineering Guide',
    description: 'Best practices for writing effective AI prompts',
    icon: <DescriptionIcon />,
    href: '/docs/default/component/avid-developer-portal/ai-central/resources/prompt-engineering/',
  },
  {
    title: 'MCP Server Guide',
    description: 'Setting up and using Model Context Protocol servers',
    icon: <CodeIcon />,
    href: '/docs/default/component/avid-developer-portal/ai-central/resources/mcp-guide/',
  },
  {
    title: 'AI Best Practices',
    description: 'Guidelines for responsible AI usage in development',
    icon: <TuneIcon />,
    href: '/docs/default/component/avid-developer-portal/ai-central/resources/best-practices/',
  },
  {
    title: 'Agentic Design Patterns',
    description: 'Architectural patterns for agentic systems',
    icon: <DescriptionIcon />,
    href: '/docs/default/component/avid-developer-portal/ai-central/guides/agentic-design-patterns/',
  },
];

export const ResourcesSection = () => {
  const classes = useStyles();

  return (
    <InfoCard
      title="Resources"
      action={
        <Button
          size="small"
          endIcon={<ArrowForwardIcon />}
          className={classes.viewAllButton}
          href="/docs/default/component/avid-developer-portal/ai-central/resources/"
        >
          View All
        </Button>
      }
    >
      <List className={classes.list}>
        {resources.map(resource => (
          <ResourceCard key={resource.title} resource={resource} />
        ))}
      </List>
    </InfoCard>
  );
};
